export class NumberRange {
  minValue = 0;
  maxValue = 0;
}
